/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';
import { followTagsUtils, type FollowingPageOptions, type FollowingSection } from '../utils/followTagsApi';

// Spelled out per section rather than interpolated, so each key stays findable.
const REVIEWS_LABEL_KEY: Record<FollowingSection, string> = {
	'forum.index.following': 'glowingblue-orell-rezensionen.forum.index.following.following_reviews_label',
	'admin.settings': 'glowingblue-orell-rezensionen.admin.settings.following_reviews_label',
};

// `followingPageOptions` is a plain function, so neither extend() nor override() reaches it. It is
// replaced instead (see admin/index.ts and forum/extend/addFollowedReviews.tsx), keeping the
// original here to build on.
const original = followTagsUtils.followingPageOptions;

export default (section: FollowingSection): FollowingPageOptions => {
	const options = original(section);

	options.reviews = app.translator.trans(REVIEWS_LABEL_KEY[section]);
	if (options.tags) {
		options.reviewsTags = options.tags;
	}
	if (options.users) {
		options.reviewsUsers = options.users;
	}

	return options;
};
